/* eslint-disable */

window.onload = function () {
    const buttons = document.querySelectorAll(".btn");

    buttons.forEach((button) => {
        button.addEventListener("click", function (e) {
            const targetEl = e.currentTarget;

            const oldRipple = targetEl.querySelector(".ripple");
            if (oldRipple) {
                oldRipple.remove();
            }

            const rippleDiv = document.createElement("span");
            rippleDiv.classList.add("ripple");

            const size = Math.max(targetEl.offsetWidth, targetEl.offsetHeight);
            rippleDiv.style.width = rippleDiv.style.height = `${size}px`;

            rippleDiv.style.left = `${e.offsetX - size / 2}px`;
            rippleDiv.style.top = `${e.offsetY - size / 2}px`;

            targetEl.appendChild(rippleDiv);

            setTimeout(() => {
                if (rippleDiv && rippleDiv.parentNode) {
                    rippleDiv.parentNode.removeChild(rippleDiv);
                }
            }, 600);
        });
    });
};
